<div class="flex flex-col gap-3">
  <h4 class="m-0 text-xs font-semibold uppercase tracking-wide text-slate-400">
    {{ 'common.documents.clarifications.title' | translate }}
  </h4>

  <!-- Thread -->
  <div class="flex flex-col gap-2 max-h-48 overflow-y-auto">
    @if (sortedClarifications().length === 0) {
      <p class="text-xs text-slate-400">
        {{ 'common.documents.clarifications.empty' | translate }}
      </p>
    } @else {
      @for (c of sortedClarifications(); track c.id) {
        <div
          class="rounded-xl px-3 py-2 text-sm"
          [class]="
            c.isFromAccountant
              ? 'ml-6 bg-blue-50 text-blue-900'
              : 'mr-6 bg-slate-100 text-slate-800'
          "
        >
          <p class="m-0 text-[11px] font-semibold text-slate-500 mb-1">
            {{ c.user.firstName }} {{ c.user.lastName }}
          </p>
          <p class="m-0 leading-relaxed">{{ c.message }}</p>
          <p class="m-0 mt-1 text-[10px] text-slate-400">
            {{ c.createdAt | date: 'dd.MM.yyyy HH:mm' }}
          </p>
        </div>
      }
    }
  </div>

  <!-- Input area -->
  <div class="flex flex-col gap-2">
    <textarea
      pTextarea
      [rows]="2"
      [placeholder]="placeholder()"
      [ngModel]="message()"
      (ngModelChange)="message.set($event)"
      class="w-full resize-none text-sm"
      data-testid="document-clarifications-input"
    ></textarea>
    <p-button
      [label]="submitLabel()"
      icon="pi pi-send"
      size="small"
      [disabled]="!canSend()"
      [loading]="isSending()"
      data-testid="document-clarifications-submit-button"
      (onClick)="onSend()"
    />
  </div>
</div>
